/**
 * Configuration alertyjs
 */
alertify.set('notifier', 'delay', 10);

/**
 * Global ajax error handler.
 *
 * Handles error cods :
 *  - 500 (app error, to show a message) ;
 *  - 401 (need to reconnect).
 *
 */
let loginModal;  // login modal instance
$(document).ajaxError(function(event, xhr) {
    const status = xhr.status;

    // Eventually clear current modal backdrop
    //if ($('.modal-backdrop').length) {
    //    $('.modal-backdrop').remove()
    //}

    const response = xhr.responseJSON;

    // // Affichage de messages si présents dans la réponse.
    // if (response && response.messages) {
    //     Notification.notifyMessages(response.messages);
    //     notified = true;
    // }

    // Error 500
    if (status == 500) {
        let message = "<strong>Une erreur technique est survenue</strong>";

        if (response && response.error) {
            if (response.error.message) {
                message += '<br>' + response.error.message;
            }

            if (response.error.exception) {
                response.error.exception.forEach(exception => {
                    message += '<br>' + exception.class;
                    message += '<br>' + exception.message;
                    message += '<ol class="trace">';
                    exception.trace.forEach(trace => {
                        message += '<li>';
                        if (trace.short_class) {
                            message += 'at <strong title="' + trace.class + '">' + trace.short_class + '::' + trace.function + '</strong><br>';
                        } else {
                            message += 'at ' + trace.file + '<br>';
                        }
                        message += 'line : ' + trace.line;
                        message += '</li>';
                    })
                    message += '</ol>';
                });
            }
        }

        Notifications.error(message);
    } else if (status == 400) {
        let message = "<strong>Une erreur fonctionnelle est survenue</strong>";

        if (response && response.error) {
            if (response.error.message) {
                message = "<strong>" + response.error.message + "</strong>";
            }
        }
        Notifications.error(message)
    } else if (status == 404) {
        Notifications.error("Page inconnue")
    } else if (status == 405) {
        Notifications.error("Méthode non autorisée")
    } else if (status == 403) {
        Notifications.error("Cette opération n'est pas autorisée.")
    } else if (status == 401) {
        if (response.login_url) {
            if (!loginModal) {
                loginModal = new $.fn.ajaxModal.Constructor({
                    url: response.login_url,
                    modalClass: 'modal-login'
                })
            }
            loginModal.show()
        }
    }
});

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

(function($) {

    function updateTopNavBar() {
        var top = $('#app_topnavbar-wrapper');

        if ($(window).scrollTop() < 15) {
            top.removeClass('scrolled');
        } else {
            top.addClass('scrolled');
        }
    }

    $(function() {
        $(window).on('scroll', updateTopNavBar);
        updateTopNavBar();
    })

})(jQuery);

/**
 * Select2 defaults
 */
$.fn.select2.defaults.set('language', 'fr');

import 'popper.js';

import './theme/jquery.ui.touch-punch';
import './form/form';
import './form/commissions';
import './form/tableauBord';
import './form/signature';
import './form/loading';
import './form/statsCommercial';
import './form/statsGestion';
import {select2AjaxChoice} from './form/select2AjaxChoice';
import {selectDropdowns} from './form/select';
import {autocompleteVilles, uppercaseInput, capitalizeInput} from './form/autocomplete';
import {tiersAdresseForm} from './form/tiersAdresse';
import {factureChoiceForm} from './form/factureChoice';
import {achatChoiceForm} from './form/achatChoice';
import {editableChoice} from './form/editableChoice';
import {articleSelector} from './form/articleSelector';
import {articleCollection} from './form/articleCollection';
import {ligneChargementCollection} from './form/ligneChargementCollection';
import {ligneFactureCollection} from './form/ligneFactureCollection';
import {ligneFactureLibreCollection} from './form/ligneFactureLibreCollection';
import {ligneAchatCollection} from './form/ligneAchatCollection';
import {ligneLivraisonCollection} from './form/ligneLivraisonCollection';
import {chargementPieceJointeCollection} from './form/chargementPieceJointeCollection';
import {initNextTabButton} from './form/tabs';
import {scrollBars} from './form/scrollbar';
import {toggleState, switchMenuState} from './theme/layout';

// Initialize material On startup
$(() => {
    $.material.init();
    select2AjaxChoice();
    selectDropdowns();
    autocompleteVilles();
    uppercaseInput();
    capitalizeInput();
    tiersAdresseForm();
    factureChoiceForm();
    achatChoiceForm();
    editableChoice();
    articleSelector();
    articleCollection();
    ligneChargementCollection();
    ligneFactureCollection();
    ligneFactureLibreCollection();
    ligneAchatCollection();
    ligneLivraisonCollection();
    chargementPieceJointeCollection();
    initNextTabButton();
    scrollBars();
    toggleState();
    switchMenuState();
});

$(window).on('resize', debounce(switchMenuState, 300));


// WEBPACK FOOTER //
// ./js/app.js